import styled, { keyframes } from "styled-components";

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  padding: 3rem 1.5rem;
  gap: 1.25rem;
`;

export const PaymentBanner = styled.div<{ $variant: "success" | "neutral" }>`
  width: 100%;
  max-width: 720px;
  border-radius: 12px;
  padding: 0.875rem 1.25rem;
  display: flex;
  align-items: center;
  gap: 0.625rem;
  font-size: 0.9rem;
  font-weight: 500;

  background: ${(props) => (props.$variant === "success" ? "#ECFDF5" : "#F8FAFC")};
  border: 1px solid ${(props) => (props.$variant === "success" ? "#A7F3D0" : "#E2E8F0")};
  color: ${(props) => (props.$variant === "success" ? "#065F46" : "#475569")};

  svg {
    flex-shrink: 0;
  }
`;

export const CreditsCard = styled.div`
  width: 100%;
  max-width: 720px;
  background: #ffffff;
  border: 1px solid #ececec;
  border-radius: 16px;
  padding: 2rem 2.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  text-align: center;
`;

export const CreditsLabel = styled.span`
  color: #6b7280;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;

export const CreditsAmount = styled.span`
  color: #111827;
  font-size: 3rem;
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.1;
`;

export const CreditsDescription = styled.p`
  margin: 0;
  color: #4b5563;
  font-size: 0.9rem;
  line-height: 1.55;
  max-width: 480px;
`;

export const PackCard = styled.div`
  width: 100%;
  max-width: 720px;
  background: #f0fffe;
  border: 1px solid #67d9d4;
  border-radius: 16px;
  padding: 2rem 2.25rem;
  display: flex;
  align-items: center;
  gap: 2rem;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1.5rem;
    padding: 1.5rem;
  }
`;

export const PackLeft = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;

export const PackBadge = styled.span`
  display: inline-block;
  background: #ccfbf7;
  color: #0d9488;
  border: 1px solid #99f6e4;
  border-radius: 6px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 3px 10px;
  width: fit-content;
`;

export const PackTitle = styled.h2`
  margin: 0;
  color: #111827;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.3;
`;

export const PackDescription = styled.p`
  margin: 0;
  color: #4b5563;
  font-size: 0.875rem;
  line-height: 1.55;
`;

export const PackRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.875rem;
  flex-shrink: 0;

  @media (max-width: 600px) {
    align-items: flex-start;
    width: 100%;
  }
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 0.25rem;
`;

export const PriceAmount = styled.span`
  color: #111827;
  font-size: 2.5rem;
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1;
`;

export const PriceCurrency = styled.span`
  color: #6b7280;
  font-size: 1.1rem;
  font-weight: 500;
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const BuyButton = styled.button`
  background: #001d30;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.625rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: background 0.2s;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background: #002c4a;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  svg.spin {
    animation: ${spin} 1s linear infinite;
  }

  @media (max-width: 600px) {
    width: 100%;
    justify-content: center;
  }
`;

export const BackToChatLink = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #64748b;
  font-size: 0.82rem;
  padding: 0.25rem 0;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  transition: color 0.2s;

  &:hover {
    color: #67d9d4;
  }
`;
